import EditLink from './EditLink';

interface DescriptionListItemProps {
	title: string;
	value?: string | number | string[] | null;
	onEdit?: () => void;
	editTestId?: string;
}

const DescriptionListItem = ({ title, value, onEdit, editTestId }: DescriptionListItemProps) => {
	const hasValue =
		value !== undefined &&
		value !== null &&
		value !== '' &&
		!(Array.isArray(value) && value.length === 0);

	return (
		<div className="mb-4">
			<dt className="text-sm font-bold text-muted-foreground mb-2">
				{onEdit ? (
					<button
						type="button"
						onClick={onEdit}
						className="inline-flex items-center gap-2 group cursor-pointer font-bold text-muted-foreground hover:text-foreground transition-colors"
						data-testid={editTestId}
					>
						{title}
						<EditLink />
					</button>
				) : (
					title
				)}
			</dt>
			<dd className="font-bold text-foreground">
				{hasValue ? (
					Array.isArray(value) ? (
						<div>
							{value.map((line, i) => (
								<span key={String(line)}>
									{String(line)}
									{i < value.length - 1 ? <br /> : null}
								</span>
							))}
						</div>
					) : (
						<span>{value}</span>
					)
				) : (
					<div className="animate-pulse opacity-100 h-4 bg-muted rounded w-20" />
				)}
			</dd>
		</div>
	);
};

export default DescriptionListItem;
